import { getNegationPrefix } from '../common/negatable.js';
import { getOperatorSymbol } from '../common/operator.js';
export function buildNumericRangeField(config) {
    return {
        toQuerySyntax() {
            const prefix = getNegationPrefix(config);
            const { field, from, to } = config;
            const operator = getOperatorSymbol('isExactly');
            return `${prefix}@${field}${operator}${from}..${to}`;
        },
    };
}
